export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/Falcohm6TM",
  instagram: "https://www.instagram.com/falcohm6tm/",
};
